import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  dealsFilters: [
    {
      filterType: '',
      filterValue: '',
    },
  ],
  /** When true (seoPageType === 'static-search'), filters are editable/removable. */
  dealsFiltersEditable: false,
  /** Filter types the user has explicitly cleared (on editable pages). Prevents re-apply. */
  dealsFiltersUserCleared: [] as string[],
  dealsPromotion: {
    id: '',
    promotionName: '',
    minimumOccupancyRule: '',
    maximumOccupancyRule: '',
    adultAgeRule: '',
    adultAge: '',
    adultRangeStart: '',
    adultRangeEnd: '',
    minorAgeRule: '',
    minorAge: '',
    minorRangeStart: '',
    minorRangeEnd: '',
    juniorAgeRule: '',
    juniorAge: '',
    juniorRangeStart: '',
    juniorRangeEnd: '',
    periodLabel: '',
    startDate: '',
    endDate: '',
  },
  templateName: '',
};

const dealsConfigSlice = createSlice({
  name: 'dealsConfig',
  initialState,
  reducers: {
    setDealsConfigs: (state, action) => {
      state.dealsFilters = action.payload;
      state.dealsFiltersUserCleared = [];
    },
    setDealsFiltersEditable: (state, action: PayloadAction<boolean>) => {
      state.dealsFiltersEditable = action.payload;
    },
    addDealsFilterUserCleared: (state, action: PayloadAction<string>) => {
      const ft = action.payload;
      if (!state.dealsFiltersUserCleared.includes(ft)) {
        state.dealsFiltersUserCleared.push(ft);
      }
    },
    setDealsPromotions: (state, action) => {
      state.dealsPromotion = action.payload;
    },
    setTemplateName: (state, action) => {
      state.templateName = action.payload;
    },
    /** Updates a single deal filter's filterValue by filterType (e.g. to sync airport presets with Algolia-available codes). */
    updateDealsFilterValue: (
      state,
      action: PayloadAction<{ filterType: string; filterValue: any }>
    ) => {
      const { filterType, filterValue } = action.payload;
      const index = state.dealsFilters.findIndex((f) => f.filterType === filterType);
      if (index !== -1) {
        state.dealsFilters[index].filterValue = filterValue;
      }
    },
  },
});

export const {
  setDealsConfigs,
  setDealsPromotions,
  setTemplateName,
  setDealsFiltersEditable,
  addDealsFilterUserCleared,
  updateDealsFilterValue,
} = dealsConfigSlice.actions;
export default dealsConfigSlice.reducer;
